<template>
    <span v-if="! status" class="status-chip-empty">&mdash;</span>
    <span v-if="status" class="status-chip" :class="toneClass">{{ label }}</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    status: {
        type: String,
        default: ''
    },
    tones: {
        type: Object,
        default: () => ({})
    }
})

const defaultTones = {
    active: 'is-success',
    approved: 'is-success',
    completed: 'is-info',
    pending: 'is-warning',
    draft: 'is-neutral',
    inactive: 'is-neutral',
    cancelled: 'is-danger',
    rejected: 'is-danger'
}

const toneClass = computed(() => {
    const tones = Object.assign({}, defaultTones, props.tones)
    return tones[props.status] || 'is-neutral'
})

const label = computed(() => String(props.status).replace(/_/g, ' '))
</script>

<style scoped>
.status-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 26px;
    padding: 0 12px;
    border-radius: 13px;
    border: 1px solid transparent;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    text-transform: capitalize;
    white-space: nowrap;
}
.status-chip::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}
.status-chip.is-success {
    background: #ecfdf3;
    border-color: #abefc6;
    color: #067647;
}
.status-chip.is-info {
    background: #eff8ff;
    border-color: #b2ddff;
    color: #175cd3;
}
.status-chip.is-warning {
    background: #fffaeb;
    border-color: #fedf89;
    color: #b54708;
}
.status-chip.is-danger {
    background: #fef3f2;
    border-color: #fecdca;
    color: #b42318;
}
.status-chip.is-neutral {
    background: #f9fafb;
    border-color: #e4e7ec;
    color: #475467;
}
.status-chip-empty {
    color: #98a2b3;
}
</style>
